// extracted by mini-css-extract-plugin
export default {"default":"anchor_default__ISktX","underline-on-hover":"anchor_underline-on-hover__z6Rkg"};